import { mapState } from 'vuex'
import { numberWithSeparator } from '@/utils/format-strings'

export default {
  name: 'PrimaryInfo',
  props: {
    paymentGroups: {
      /**
       * Array<{
       *   adjustments_sum: number,
       *   balance: number,
       *   fuel_money_given: number,
       *   orders_count: number,
       *   orders_sum: number,
       *   payment_type: string
       * }>
       */
      type: Array,
      required: true
    },
    /**
     * объект имеет в том числе и все те поля, 
     * которые есть у элеметов массива paymentGroups,
     * за исключением payment_type
     */
    primaryInfo: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapState({
      paymentTypes: state => state.sharedData.paymentTypes
    })
  },
  methods: {
    numberWithSeparator,
    getAmountStr(amount) {
      let result = ''
      if (amount > 0) {
        result += '+'
      }
      result += `${this.numberWithSeparator(amount)} ₽`
      return result
    }
  }
}